// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#import-topics-page .topics-page-column > div > .box-container {\n  box-shadow: none;\n}\n", "",{"version":3,"sources":["webpack://./src/css/pages/ImportTopics.styl"],"names":[],"mappings":"AACE;EACE,gBAAW;AAAf","sourcesContent":["#import-topics-page\n  .topics-page-column > div > .box-container\n    box-shadow none\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
